// -------Border Radius-----------------------------------------------------

const shape = {
  borderRadius: 8,
  borderRadiusSm: 8,
  borderRadiusMd: 8
};

export default shape;
